import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { EntityActions } from 'actions';

import ContentLayout from 'containers/components/layouts/ContentLayout';
import CampaignsHeader from './CampaignsHeader';
import ActivityCampaigns from './ActivityCampaigns';
import MarketingCampaigns from './MarketingCampaigns';

import './styles.scss';

const propTypes = {
    login: PropTypes.bool.isRequired,
};

const Main = memo(({ login, isPageForbidden }) => {
    if (!login) return null;
    if (isPageForbidden(['verCampaignsAdmin'])) return null;

    return (
        <ContentLayout header={<CampaignsHeader />}>
            <Routes>
                {/* Redirect /campaigns to /campaigns/activity */}
                <Route path="/" element={<Navigate to="/campaigns/activity" replace />} />
                {/* Activity Campaigns routes */}
                <Route path="/activity/*" element={<ActivityCampaigns />} />
                {/* Marketing Campaigns routes */}
                <Route path="/marketing/*" element={<MarketingCampaigns />} />
            </Routes>
        </ContentLayout>
    );
});

function mapStateToProps(state) {
    return {
        login: state.config.login,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        isPageForbidden: bindActionCreators(EntityActions, dispatch).isPageForbidden,
    };
};

Main.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(Main);
